// src/modules/public/pages/SignUpPage/index.js
import React, { useState, useEffect } from 'react';
import { useWarmupTimer } from '../../../../shared/hooks/useWarmupTimer';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../shared/hooks/useAuth';
import { useAlert } from '../../../../shared/hooks/useAlert';
import SignUpForm from '../../components/SignUpForm';
import Loading from '../../../../shared/components/Loading';

const SignUpPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { isWarmup } = useWarmupTimer(isLoading);
    const { signUp, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const { alert, showError, hideAlert } = useAlert();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/fithub');
        }
    }, [isAuthenticated, navigate]);

    const handleSignUp = async (credentials) => {
        setIsLoading(true);
        try {
            await signUp(credentials);
            navigate('/login', { state: { successMessage: 'Account created successfully! Check your email and click the verification before logging in.' } });
        } catch (error) {
            showError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="mt-5">
            {isLoading ? (
                <Loading isWarmup={isWarmup} />
            ) : (
                <SignUpForm
                    onSubmit={handleSignUp}
                    isLoading={isLoading}
                    alert={alert}
                    onAlertClose={hideAlert}
                />
            )}
        </Container>
    );
};

export default SignUpPage;